/* eslint-disable consistent-this */
/* eslint-disable require-jsdoc */
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
// import elementVariables from '@/styles/element-variables.scss';
import defaultSettings from '@/AppSettings';

/** 系统设置 */
export interface ISettingsState {
	theme: string;
	fixedHeader: boolean;
	showSettings: boolean;
	showTagsView: boolean;
	showSidebarLogo: boolean;
	sidebarTextTheme: boolean;
}

/**
 * 首页选择模式
 *
 * @export
 * @enum {number}
 */
// eslint-disable-next-line no-shadow
export enum indexModeData {
	ENTRACNE_MODE = 'entrance_mode',
	SELECT_MODE = 'select_mode'
}

/** 系统设置 */
// eslint-disable-next-line object-property-newline
@Module({ dynamic: true, store, name: 'settings' })
class Settings extends VuexModule implements ISettingsState {
	public theme: any = '';
	public fixedHeader: any = defaultSettings.fixedHeader;
	public showSettings: any = defaultSettings.showSettings;
	public showTagsView: any = defaultSettings.showTagsView;
	public showSidebarLogo: any = defaultSettings.showSidebarLogo;
	public sidebarTextTheme: any = defaultSettings.sidebarTextTheme;

	/** mutation 更改设置 */
	@Mutation
	private CHANGE_SETTING(payload: { key: string; value: any }): any {
		const { key, value }: any = payload;

		// eslint-disable-next-line prefer-reflect
		if (Object.prototype.hasOwnProperty.call(this, key)) {
			// eslint-disable-next-line consistent-this
			// eslint-disable-next-line @typescript-eslint/no-this-alias
			const thisVal: any = this;

			thisVal[key] = value;
		}
	}

	/** 更改设置 */
	@Action
	public changeSetting(payload: { key: string; value: any }): any {
		this.CHANGE_SETTING(payload);
	}

	/**
	 * 首页显示模式
	 *
	 * @type {string}
	 * @memberOf Settings
	 */
	public indexMode: string = indexModeData.ENTRACNE_MODE;

	/** mutation 首页显示模式 */
	@Mutation
	private CHANGE_INDEX_MODE(payload: string): any {
		this.indexMode = payload;
	}

	/** action 首页显示模式 */
	@Action
	public saveIndexMode(payload: string): any {
		this.CHANGE_INDEX_MODE(payload);
	}

	/**
	 * 选择场景步骤
	 * 1,2,3
	 *
	 * @type {string}
	 * @memberOf Settings
	 */
	public active: number = 1;

	/** mutation 选择场景步骤 */
	@Mutation
	private CHANGE_ACTIVE(payload: number): any {
		this.active = payload;
	}

	/** action 首页显示模式 */
	@Action
	public changeActive(payload: number): any {
		this.CHANGE_ACTIVE(payload);
	}

	/**
	 * 动态扩展组件存储数据
	 * 1,2,3
	 *
	 * @type {string}
	 * @memberOf Settings
	 */
	public extendCriteriaData: any = {};

	/** mutation 更新动态扩展组件存储数据 */
	@Mutation
	private UPDATE_EXTEND_CRITERIA_DATA(payload: any): any {
		this.extendCriteriaData = payload;
	}

	/** action 保存动态扩展组件存储数据 */
	@Action
	public updateExtendCriteriaData(payload: any): any {
		this.UPDATE_EXTEND_CRITERIA_DATA(payload);
	}
}

/** document hooks */
export const settingsModule: any = getModule(Settings);
